/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
type SiteNav_viewer$ref = any;
type SuspectedTradeUserLazy_viewer$ref = any;
type TradeAccountManagerLink_viewer$ref = any;
type VipAccountManagerLink_viewer$ref = any;
import type { FragmentReference } from "relay-runtime";
declare export opaque type BottomBar_viewer$ref: FragmentReference;
export type BottomBar_viewer = {|
  +$fragmentRefs: SiteNav_viewer$ref & VipAccountManagerLink_viewer$ref & TradeAccountManagerLink_viewer$ref & SuspectedTradeUserLazy_viewer$ref,
  +$refType: BottomBar_viewer$ref,
|};
*/


const node/*: ReaderFragment*/ = {
  "kind": "Fragment",
  "name": "BottomBar_viewer",
  "type": "Viewer",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "SiteNav_viewer",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "VipAccountManagerLink_viewer",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "TradeAccountManagerLink_viewer",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "SuspectedTradeUserLazy_viewer",
      "args": null
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = 'cf5f968280aeb056e81a3764a220ccff';
module.exports = node;
